<template>
  <div class="app-root">
    <h2>
      Mereäärne kinnistu Harjumaal Lääne-Harju vallas Pakri poolsaarel, mille
      hinna üle omanik keskkonnaametiga vaidleb
    </h2>
    <div class="map"></div>
  </div>
</template>

<style scoped>
.app-root {
  --section-color: #0064fa;
  --section-secondary-color: #0000ba;
  --section-tertiary-color: #a5e6e9;
  --line: #d5d8dd;
  --gray: #717c8e;
  --lightest: #eef3f6;
  --text-color: #262626;

  width: 100%;
  height: 100%;

  position: relative;

  display: flex;
  flex-direction: column;

  font-family: GT Eesti, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;

  font-size: clamp(12px, 2.4vw, 16px);
  line-height: 1;

  color: var(--text-color);

  -webkit-tap-highlight-color: transparent;
}

h2 {
  margin: 0;
  font-size: 1.75em;
  line-height: 1.35;

  margin-bottom: 0.5em;
}

.map {
  flex-grow: 1;
  width: 100%;
  height: 100%;

  box-sizing: border-box;
  border: 1px solid var(--line);
  border-radius: 4px;
}
</style>

<script setup>
import { ref, computed, onMounted, onUnmounted, inject, nextTick } from "vue";

const containerElement = inject("containerElement");

const kinnistuCoordinates = [
  [59.3507633697, 24.1740605493],
  [59.3505825674, 24.1738001824],
  [59.3505327527, 24.1737283882],
  [59.3495846799, 24.1759968494],
  [59.3498738765, 24.1767532858],
  [59.3500018798, 24.177088446],
  [59.3506993439, 24.1763657349],
  [59.3510430254, 24.1762551808],
  [59.3512182957, 24.175750536],
  [59.3512109269, 24.1753535844],
  [59.351250046, 24.1747614016],
  [59.3507633697, 24.1740605493],
];

const kinnistuCoordinates2 = [
  [59.3482659186, 24.175537301],
  [59.3488814317, 24.1771496219],
  [59.3492101132, 24.1763793359],
  [59.3486671464, 24.1749505339],
  [59.3482659186, 24.175537301],
];

let map;

async function initMap() {
  map = L.map(containerElement.querySelector(".map"), {
    onMapReady(map) {
      setTimeout(() => {
        map.invalidateSize(true);
      }, 1000);
    },
    zoomControl: false, // add manually
    zoom: 15,
    center: [59.349398, 24.173563],
  });

  const tileServer = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
  const attribution = `&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> | 
    <a href="https://postimees.ee">Postimees</a>`;
  const tiles = L.tileLayer(tileServer, { attribution });
  tiles.addTo(map);

  L.control
    .zoom({
      position: "topleft",
    })
    .addTo(map);

  L.control.scale().addTo(map);

  const style = {
    color: "#0064fa",
    weight: 2,
    fillOpacity: 0.05,
  };

  const kinnistu = L.polygon(kinnistuCoordinates, {
    ...style,
  })
    .bindPopup(
      `<b>Jaan Puusaagi kinnistu, <br/>omanik soovib
<span>162 000</span> eurot, <br/>riik pakub <span>18 000</span> eurot</b>`
    )
    .addTo(map);

  const kinnistu2 = L.polygon(kinnistuCoordinates2, {
    ...style,
  })
    .bindTooltip(`<b>Müügis olev kinnistu <br/>hinnaga 146 500 eurot</b>`)
    .addTo(map);

  // map.fitBounds(kinnistu.getBounds());

  //
  await nextTick();

  kinnistu.openPopup();
  kinnistu2.openTooltip();

  //
  map.invalidateSize();
  window.setTimeout(map.invalidateSize, 1000);

  m.openPopup();
  j.openTooltip();

  // open attribution links in new tab
  const links = containerElement.querySelectorAll("a");
  links.forEach((a) => {
    if (a.href.startsWith("http") && !a.href.includes("#")) {
      // console.log(a);
      a.setAttribute("target", "_blank");
    }
  });

  //
  /*map.on("click", (e) => {
    const { latlng } = e;
    const { lat, lng } = latlng;
    console.log(`${lat}, ${lng}`);
  });*/
}

// lifecycle
onMounted(() => {
  initMap();
});

onUnmounted(() => {});
</script>

<script>
export default {
  name: "App",
};
</script>
